import normalizeComponent from "../../../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "&#229;&#133;&#179;&#233;&#151;&#173; &#233;&#148;&#153;&#232;&#175;&#175;" } }, [_c("path", { attrs: { "id": "Vector", "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M10.0007 17.5002C14.1428 17.5002 17.5006 14.1423 17.5006 10.0002C17.5006 5.85803 14.1428 2.50016 10.0007 2.50016C5.85852 2.50016 2.50065 5.85803 2.50065 10.0002C2.50065 14.1423 5.85852 17.5002 10.0007 17.5002ZM19.1673 10.0002C19.1673 15.0627 15.0632 19.1668 10.0007 19.1668C4.93804 19.1668 0.833984 15.0627 0.833984 10.0002C0.833984 4.93756 4.93804 0.833496 10.0007 0.833496C15.0632 0.833497 19.1673 4.93756 19.1673 10.0002ZM6.17021 12.6521L8.82215 10.0002L6.17021 7.34823L7.34872 6.16972L10.0007 8.82166L12.652 6.17029L13.8306 7.3488L11.1791 10.0002L13.8306 12.6515L12.652 13.8301L10.0007 11.1787L7.34872 13.8306L6.17021 12.6521Z", "fill": "currentColor" } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const error = __component__.exports;
export {
  error as default
};
